// src/schedule/Avatar.jsx
import React from "react";
import { ICONS } from "../icons/employeeIcons";

export default function Avatar({ employee, size = 20, title }) {
    const emp = typeof employee === "string" ? { name: employee } : employee || {};
    const name = emp.name || "";
    const url = emp.avatarUrl || null;
    const iconKey = emp.iconKey || null;

    const initials = name
        ? name
            .trim()
            .split(/\s+/)
            .map((s) => s[0]?.toUpperCase())
            .slice(0, 2)
            .join("")
        : "•";

    const boxStyle = { width: size, height: size };

    if (url) {
        return (
            <img
                src={url}
                alt={title || name || "avatar"}
                className="rounded-full object-cover flex-shrink-0"
                style={boxStyle}
            />
        );
    }

    const Icon = iconKey && ICONS[iconKey] ? ICONS[iconKey] : null;
    if (Icon) {
        return (
            <div
                className="rounded-full bg-gray-200 text-gray-900 flex items-center justify-center flex-shrink-0"
                style={boxStyle}
                title={title || name}
            >
                <Icon size={Math.round(size * 0.62)} />
            </div>
        );
    }

    return (
        <div
            className="rounded-full bg-gray-700 text-white grid place-items-center text-[11px] font-semibold flex-shrink-0"
            style={boxStyle}
            title={title || name}
        >
            {initials}
        </div>
    );
}
